<template>
  <!-- <v-banner v-model="localShowBanner" app sticky transition="slide-y-transition" color="secondary">
    <v-row>
      <v-col cols="12">
        <v-icon slot="icon" size="30" >
          mdi-alert-circle
        </v-icon>
        Your session has expired. Refresh the page to renew the session
        <v-btn @click="refreshPage" rounded  outlined class="rounded-xl ml-3 px-5">
          Refresh
        </v-btn>
      </v-col>
    </v-row>
  </v-banner> -->
  <v-dialog v-model="localShowBanner" persistent max-width="450"  height="auto" class="rounded-xl">
    <v-card class="rounded-xl pa-3 pt-4 px-2 text-center" max-width="500" height="auto">
      <!-- <v-avatar
                class="ma-3"
                size="125"
                tile
              > -->
                <v-img :src="imageUrl" height="200" aspect-ratio="1.6" contain class="mt-8 mb-3"></v-img>
              <!-- </v-avatar> -->
      <v-card-title class="text-h5 d-flex align-center justify-center ma-0 pb-1">
        <span class="text-center">
          Your session has expired

        </span>
      </v-card-title>
      <v-card-text class="mt-0">
         Refresh the page to renew session.
      </v-card-text>
      <v-card-actions class="mt-0 pt-0 mb-5">
        <v-spacer></v-spacer>
        <v-btn  class="px-4" rounded depressed @click="refreshPage" >
          Refresh
        </v-btn>
        <v-spacer></v-spacer>

      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      localShowBanner: this.showBanner
    }
  },
  props: {
    showBanner: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      required: true
    }
  },
  watch: {
    showBanner (newVal) {
      this.localShowBanner = newVal
    }
  },
  methods: {
    refreshPage () {
      window.location.href = '/' + '?cache_bust=' + new Date().getTime()
    }
  }
}
</script>
